<template>
  <div style="border-radius: 9px" class="pa-4 white">
    <v-tabs grow color="secondary" v-model="reportTab">
      <v-tab
        v-for="(page, id) in reportPages"
        class="rounded-lg rounded-b-0"
        :key="id"
        @click="report.setPage(page.name)"
      >
        {{ page.displayName }}
      </v-tab>
    </v-tabs>
    <div id="reportContainer">
      <!-- <iframe
        title="Equipacare Dummy"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&autoAuth=true&ctid=08f25003-a45c-49fb-8090-a8e9c45925d6"
        frameborder="0"
        allowFullScreen="true"
      ></iframe> -->
    </div>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client'
import ApiService from '../../../services/ApiService'

export default {
  data() {
    return {
      report: null,
      reportTab: null,
      reportPages: [],
      apiService: new ApiService(),
      tokens: {},
    }
  },

  async mounted() {
    await this.getToken()
    try {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      const powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      )

      let models = pbi.models

      var basicFilter4 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'serviceorders',
          column: 'InstitutionId',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      var basicFilter5 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'calleds',
          column: 'InstitutionId',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      var basicFilter6 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'equipment',
          column: 'InstitutionId',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      var basicFilter7 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'unidades',
          column: 'InstitutionId',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      var basicFilter8 = {
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'institutions',
          column: 'Id',
        },
        operator: 'In',
        values: [institutionId],
        filterType: 1,
      }

      let embedConfiguration = {
        type: 'report',
        id: '0ec21473-9d15-4e01-a3f2-7c9c1353f4b7',
        embedUrl:
          'https://app.powerbi.com/reportEmbed?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1CLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3D',
        tokenType: models.TokenType.Embed,
        accessToken: this.tokens.token,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
      }

      let reportContainer = document.getElementById('reportContainer')

      this.report = powerbi.embed(reportContainer, embedConfiguration)

      const self = this

      this.report.on('loaded', (event) => {
        this.report.getFilters().then(async (filters) => {
          filters.push(
            ...[
              basicFilter4,
              basicFilter5,
              basicFilter6,
              basicFilter7,
              // basicFilter8,
            ]
          )

          self.reportPages = await self.report.getPages()

          self.reportPages = self.reportPages.filter(
            (x) => x.visibility === 0 && x.displayName == 'Dashboard'
          )

          self.report.setPage(self.reportPages[0].name)

          return self.report.setFilters(filters)
        })
      })
    } catch (err) {}
  },

  methods: {
    async getToken() {
      await this.apiService
        .get(
          'consumptionReading/getAccessToken?reportId=0ec21473-9d15-4e01-a3f2-7c9c1353f4b7&datasetId=509c084a-a659-407b-b002-61d57b5068da'
        )
        .then((response) => {
          this.tokens = response.content
        })
    },
  },
}
</script>

<style scoped>
#reportContainer {
  height: 70vh;
  width: 100% !important;
}
</style>
